import React, { Component } from "react";
import { findIndex } from "lodash";
import { Button, Modal } from "react-bootstrap";
import {
  TEXT_CANCEL,
  TEXT_SAVE,
  MAX_WIDTH_SP,
  RING_SIZE_DEFAULT,
  RING_COLOR_DEFAULT,
  ID_RING_TYPE_DEFAULT
} from "../../const";
import DesignTool from "../../designtool";
import swal from 'sweetalert';

const uuid = require("uuid/v4");

export default class DialogConfirmSave extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: "",
      isError: false
    };
  }

  handleChangeValue(e) {
    this.setState({ inputValue: e.target.value, isError: false });
  }

  handleCloseDialog() {
    let { handleCloseDialog, handleUpdateState } = this.props;

    this.setState({ inputValue: "" });
    handleCloseDialog("isShowDialogConfirmSave");
    handleUpdateState("isSaveForTab", false);
  }

  handleSaveDesign() {
    let { inputValue } = this.state;
    let {
      ringIdClick,
      handleUpdateState,
      designInfo,
      isSaveForTab,
      ringIdActive,
      tmpRingIdActive,
      getWidthBrowser,
      ringTypeList,
      paramUrl
    } = this.props;

    // Check input empty
    if (inputValue === "") {
      this.setState({ isError: true });
      return;
    }

    // Save design
    let designList = JSON.parse(localStorage.getItem("products")) || [];
    let image = DesignTool.getPNGBase64();
    let items = DesignTool.getItems();
    let id = uuid();
    let product = {
      id: id,
      name: inputValue,
      image: image,
      items: items,
      ringSize: designInfo.ringSize,
      ringSizeMin: DesignTool.getSizeDesignMin(designInfo),
      ringSizeMax: DesignTool.getSizeDesignMax(designInfo),
      ringPrice: designInfo.ringPrice,
      ringId: designInfo.ringId,
      ringColor: designInfo.ringColor,
      ringColorCode: designInfo.ringColorCode,
      ringTypeId: tmpRingIdActive !== 0 ? tmpRingIdActive : ringIdActive,
      orderMadeId: paramUrl.orderMadeId,
    };

    designList.push(product);
    localStorage.setItem("products", JSON.stringify(designList));

    // Update state
    handleUpdateState("isShowDialogConfirmSave", false);
    handleUpdateState("isResetDesign", true);

    // Remove materials tray
    localStorage.setItem("materials", JSON.stringify([]));
    handleUpdateState("isUpdateMaterialsTray", true);

    // Reset fortune list
    handleUpdateState("isSaveSuccess", true);

    //Reset orderMadeId null
    handleUpdateState("paramUrl", {
      orderMadeId: null,
    });

    // show success
    swal("成功しました。", "デザインの保存に成功しました!", "success");
    // Save for change tab ring <=> earing
    if (isSaveForTab) {
      handleUpdateState("ringIdActive", ringIdClick);
      handleUpdateState("isShowModalMaterial", true);
      handleUpdateState("isSaveForTab", false);
      handleUpdateState("idMaterialActive", 1);

      //- show tab on SP version
      if (MAX_WIDTH_SP > getWidthBrowser()) {
        handleUpdateState("isShowModalRingList", true);
        handleUpdateState("isShowPopupSp", true);
      }

      //- Set default ring select
      if (this.handleSetDefaultRing(ringTypeList, ringIdClick)) {
        return;
      }

      DesignTool.initializeDesign(ringIdClick,
        document.getElementById("wrap_draw_tool"),
        {
          size: RING_SIZE_DEFAULT,
          color: RING_COLOR_DEFAULT
        },designInfo
      );
      return;
    }

    // Reset tmp design
    handleUpdateState("tmpDesignInfo", {
      ringId: 0,
      ringSize: null,
      ringSizeMin: null,
      ringSizeMax: null,
      ringColor: "",
      ringPrice: 0,
      ringColorCode: RING_COLOR_DEFAULT
    });
    handleUpdateState("tmpListItem", []);
    handleUpdateState("tmpRingIdActive", 0);
    handleUpdateState("isKeepData", false);
    handleUpdateState("ringIdActive", ID_RING_TYPE_DEFAULT);

    //- Set default ring select
    if (this.handleSetDefaultRing(ringTypeList, ID_RING_TYPE_DEFAULT)) {
      return;
    }

    DesignTool.initialize(
      ID_RING_TYPE_DEFAULT,
      document.getElementById("wrap_draw_tool"),
      {
        size: RING_SIZE_DEFAULT,
        color: RING_COLOR_DEFAULT
      }
    );
  }

  //- Handle set default ring select
  handleSetDefaultRing(ringTypeList, ringId) {
    let { handleUpdateState,designInfo } = this.props;
    let indexItem = findIndex(ringTypeList, item => item.id === ringId);
    if (indexItem !== -1) {
      let itemRing = ringTypeList[indexItem].rings[0];

      handleUpdateState("designInfo", {
        ringId: itemRing.id,
        ringSize: itemRing.sizes[0].size,
        ringSizeMin: DesignTool.getSizeDesignMin(designInfo),
        ringSizeMax: DesignTool.getSizeDesignMax(designInfo),
        ringColor: itemRing.colors[0].color_name,
        ringPrice: itemRing.price,
        ringColorCode: itemRing.colors[0].color_code
      });

      DesignTool.initializeDesign(ringId, document.getElementById("wrap_draw_tool"), {
        size: itemRing.sizes[0].size,
        color: itemRing.colors[0].color_code
      },designInfo);
      return true;
    }

    return false;
  }

  render() {
    let { isShowDialogConfirmSave } = this.props;
    let { isError } = this.state;

    return (
      <Modal
        show={isShowDialogConfirmSave}
        onHide={() => this.handleCloseDialog()}
        aria-labelledby="contained-modal-title-vcenter"
        dialogClassName="dialog_custom"
        centered
      >
        <Modal.Header>
          <span className="font-weight-bold">デザイン名</span>
        </Modal.Header>
        <Modal.Body>
          <input
            type="text"
            value={this.state.inputValue}
            onChange={e => this.handleChangeValue(e)}
            className="form-control"
            placeholder="デザイン名を入力してください"
          />
          <span className="form-error">{`${
            isError ? "デザイン名は必須です" : ""
          }`}</span>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => this.handleCloseDialog()}>
            {TEXT_CANCEL}
          </Button>
          <Button variant="primary" onClick={() => this.handleSaveDesign()}>
            {TEXT_SAVE}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
